import { FormField } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { FORM_MODES } from '../../../../../../config/formModes';
import { useFormDataContext, useFormFieldValue } from '../../../../../taboola-common-frontend-modules/formData';
import { ENTITY } from '../../../../config';
import { AllEntityId } from '../../../../config/allEntityId';
import { useLastCreatedCampaignGroupId } from '../../../../hooks/useLastCreatedCampaignGroupId';
import { useReportEntityIds } from '../../../../hooks/useReportEntityIds';
import { useReportEntityType } from '../../../../hooks/useReportEntityType';
import { useCampaignGroupEnabled } from '../../../campaigns-group-form/hooks/useCampaignGroupEnabled';
import { CampaignGroup } from './Components/CampaignGroup/CampaignGroup';
import styles from './CampaignGroupField.module.scss';

export const CampaignGroupField = props => {
    const [lastCreatedCampaignGroupId] = useLastCreatedCampaignGroupId();
    const [reportEntityIds] = useReportEntityIds();
    const [reportEntityType] = useReportEntityType();
    const selectedCampaignGroupId = reportEntityType === ENTITY.CAMPAIGNS_GROUP ? reportEntityIds : AllEntityId;
    const { mode } = useFormDataContext();
    const campaignGroupEnabled = useCampaignGroupEnabled();
    const { value } = useFormFieldValue(
        {
            field: 'campaignGroupInfo.campaignGroupId',
        },
        { initialCampaignGroupId: lastCreatedCampaignGroupId ?? selectedCampaignGroupId }
    );

    if (!campaignGroupEnabled || (mode === FORM_MODES.EDIT && !value)) {
        return null;
    }

    return (
        <FormField
            label={<FormattedMessage id="campaign.group" defaultMessage="Campaign Group" />}
            helpText={
                <FormattedMessage
                    id="campaign.name.help"
                    defaultMessage="This is an internal name only - it does not display in your ads."
                />
            }
            containerClass={styles['form-field']}
        >
            <CampaignGroup {...props} />
        </FormField>
    );
};
